module.exports = {
    types: {
        success: "success",
        warning: "warning",
        error: "error",
    },
};
